module.exports = {"name":"Emmanuelle Claeys","url":"http://www.emmanuelle-claeys.com","description":"Emmanuelle Claeys - Doctorante à l'Université de Strasbourg au laboratoire de l'Icube encadrée par Pierre Gançarski et co-encadrée par Myriam Maummy-Bertrand du laboratoire IRMA. Ma thèse est soutenue et financée par l'entreprise AB Tasty."}


//////////////////
// WEBPACK FOOTER
// ./src/metadata/metadata.json
// module id = 102
// module chunks = 0